export const INTERNAL_DATE = 'YYYY-MM-DD'
export const DISPLAY_DATE = 'D MMMM YYYY'
export const DISPLAY_DATE_WITH_DAY = 'dddd DD MMMM YYYY'
